import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import Logo from '../assets/images/logo.webp';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        {/* Logo */}
        <div className="nav-logo-container">
          <img src={Logo} alt="Paul Gold Logo" className="nav-logo-img" />
        </div>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" className={isActive('/')} onClick={() => setIsMenuOpen(false)}>
              Partner with us
            </Link>
          </li>
          <li>
            <Link to="/about" className={isActive('/about')} onClick={() => setIsMenuOpen(false)}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/terms" className={isActive('/terms')} onClick={() => setIsMenuOpen(false)}>
              Terms &amp; Conditions
            </Link>
          </li>
          <li>
            <a href="#download" className="download-link" onClick={(e) => {
              e.preventDefault();
              alert('App download coming soon! 📱');
            }}>
              Download App
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;